import { render, staticRenderFns } from "./TelegramButton.vue?vue&type=template&id=3656ded1&scoped=true"
import script from "./TelegramButton.vue?vue&type=script&lang=js"
export * from "./TelegramButton.vue?vue&type=script&lang=js"
import style0 from "./TelegramButton.vue?vue&type=style&index=0&id=3656ded1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656ded1",
  null
  
)

export default component.exports